import { createLoyaltyizationImpressionEvent } from './loyalty';
import { createGigDescriptionImpressionEvent } from './gigDescription';
import {
    createNotableClientAboveTheFoldComponentIsShown,
    createNotableClientBelowTheFoldComponentIsShown
} from './notableClients';

export const ImpressionEvents = {
    'loyalty_banner': createLoyaltyizationImpressionEvent('returning_buyers_banner'),
    'gig_description': createGigDescriptionImpressionEvent('gig_description_is_shown'),
    'notable_client_above_the_fold_component_is_shown': createNotableClientAboveTheFoldComponentIsShown('notable_clients_above_fold_is_shown'),
    'notable_client_below_the_fold_component_is_shown': createNotableClientBelowTheFoldComponentIsShown('notable_clients_below_fold_is_shown')
};
